import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { useTranslation } from 'react-i18next'
import { ButtonBind } from './ButtonBind'

interface MyAccountPhoneProps {
  isBound: boolean
  canUnBind?: boolean
  email?: string
  onClick?: () => void
}

export function MyAccountEmail(props: MyAccountPhoneProps) {
  const { t } = useTranslation()
  const { isBound, canUnBind, email, onClick } = props

  return (
    <>
      <HStack justifyContent="space-between">
        <VStack>
          <Text variant="body">{t('login.email')}</Text>
          <Text color="gray">{email || t('login.notSet')}</Text>
        </VStack>
        <ButtonBind
          isBound={isBound}
          canUnBind={canUnBind}
          text={t('login.verifyEmail')}
          onClick={onClick}
        />
      </HStack>
    </>
  )
}
